module.exports = __webpack_public_path__ + "static/media/xmcc.51b536e6.svg";